/**
 * @author yan st
 * @date 2022-08-30 13:51
 * @Description:
 */

export const homeRouter = [
  {
    path: '',
    redirect: 'index'
  },
  {
    path: 'index',
    meta: {
      title: '首页',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/page/index'),
  },
  {
    path: 'type',
    meta: {
      title: '专家分类',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/page/type'),
  },
  {
    path: 'field',
    meta: {
      title: '专家领域',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/page/field'),
  },
  {
    path: 'examine',
    meta: {
      title: '专家审核',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/page/examine'),
  },
  {
    path: 'examineDetail',
    meta: {
      title: '专家详情',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/page/examineDetail'),
  },
  {
    path: 'examineYuyue',
    meta: {
      title: '专家预约',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/page/examineYuyue'),
  },
  {
    path: 'evaluate',
    meta: {
      title: '专家评价',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/page/evaluate'),
  },
  {
    path: 'detail',
    meta: {
      title: '专家信息',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/page/detail'),
  },
  {
    path: 'detailYuyue',
    meta: {
      title: '专家预约信息',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/page/detailYuyue'),
  },
  {
    path: 'invitation',
    meta: {
      title: '专家邀请',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/page/invitation'),
  },
  {
    path: 'reservation',
    meta: {
      title: '预约信息',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/page/reservation'),
  },

  {
    path: 'information',
    meta: {
      title: '机构信息',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/page/information'),
  },
  {
    path: 'pass',
    meta: {
      title: '密码修改',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/page/pass'),
  },
  {
    path: 'feedback',
    meta: {
      title: '意见反馈',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/page/feedback'),
  },
  {
    path: 'exhibition',
    meta: {
      title: '展示页面',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/page/exhibition'),
  },
]




export default homeRouter
